module.exports = __webpack_public_path__ + "static/media/saving4.80856e47.svg";